import type React from 'react';
import type ReactDOM from 'react-dom';
import type {
  IRequestCallI18nModel,
  IRequestCallLogger,
  IRequestCallModalProps,
} from '../src/types';

/* eslint-disable */

interface IRequestCallAccount {
  AccountNumber?: string;
}

interface IPageContext {
  CurrentAccount?: IRequestCallAccount;
  Permissions?: {
    dynamic?: {
      UnifiedProductSubscription?: boolean;
    };
  };
  SupportPagePath?: string;
}

interface IComponentConfig {
  get(name: 'CurrentAccount'): IRequestCallAccount | undefined;
}

interface IRequestCallModalModule {
  RequestCallModal: React.ComponentType<IRequestCallModalProps>;
}

interface ILegacyRequire {
  (
    dependencies: string[],
    callback: (
      react: typeof React,
      reactDom: typeof ReactDOM,
      requestCallModal: IRequestCallModalModule,
      i18n: IRequestCallI18nModel,
    ) => void,
  ): void;
  (moduleName: 'PageContext'): IPageContext;
  (moduleName: 'component/config/index'): IComponentConfig;
  (moduleName: 'instrumentation/log'): IRequestCallLogger;
}

declare const require: ILegacyRequire;

$(document).ready(function(){
  $('#requestCallTrigger').click(function() {
    require([
      'react',
      'react-dom',
      '@bingads-webui-react/request-call-modal',
      '@bingads-webui/i18n-amd-loader!shared-components/request-call-modal',
    ], function (
      React,
      ReactDom,
      RequestCallModal,
      i18n
    ) {
      var accountNumber: string | undefined;
      var permissions = {
        UnifiedProductSubscription: false,
      };
      var resourcePath: string | undefined;
      var logger: IRequestCallLogger | undefined;

      try {
        var pageContext = require('PageContext');
        accountNumber = pageContext.CurrentAccount && pageContext.CurrentAccount.AccountNumber;

        permissions.UnifiedProductSubscription = pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.UnifiedProductSubscription;
        resourcePath = pageContext.SupportPagePath;
      } catch (e) { }

      if (!accountNumber) {
        try {
          var config = require('component/config/index');
          var currentAccount = config.get('CurrentAccount');
          accountNumber = currentAccount && currentAccount.AccountNumber;
        } catch (e) { }
      }

      try {
        logger = require('instrumentation/log');
      } catch (e) { }

      var close = function() {
        ReactDom.unmountComponentAtNode(document.getElementById('requestCallModalContainer'));
      };
      var modal = React.createElement(RequestCallModal.RequestCallModal, {
        isOpen: true,
        onClose: close,
        i18n: i18n,
        permissions: permissions,
        resourcePath: resourcePath,
        logger: logger,
        featureName: permissions.UnifiedProductSubscription ? 'UP' : undefined,
        context: { accountNumber: accountNumber, flowId: permissions.UnifiedProductSubscription ? 'Subscription-ads-main' : 'EXP-main-cc' }
      });
      ReactDom.render(modal, document.getElementById('requestCallModalContainer'));
    });
  });
});
